import { render, staticRenderFns } from "./SongwriterForm.vue?vue&type=template&id=1020b099"
import script from "./SongwriterForm.vue?vue&type=script&lang=js"
export * from "./SongwriterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports